import { z } from 'zod';
import { PartnerContactSchema } from '../../entities/partner/partner-contact.schema';
import { ErrorCode } from '../../../../shared/error-codes';
/** `null` or `''` clears the stored value; an absent key leaves it alone. */ const clearableText = ()=>z.string().trim().nullable().transform((v)=>v === '' ? null : v).optional();
/**
 * Update Partner Contact Request
 * PATCH /api/v2/partner/contacts/:id
 */ export const UpdatePartnerContactRequestSchema = z.object({
    firstName: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    lastName: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    email: z.email(ErrorCode.FIELD_INVALID_EMAIL).or(z.literal('')).nullable().transform((v)=>v === '' ? null : v).optional(),
    phone: clearableText(),
    company: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    note: clearableText(),
    /**
   * The rep closes a contact as "no interest", or reopens it with `null`. A
   * submitted lead is already in the CRM, so the lead outcome cannot be set or
   * undone here.
   */ outcome: z.literal('noInterest').nullable().optional()
});
export const UpdatePartnerContactResponseSchema = z.object({
    data: PartnerContactSchema
});

//# sourceMappingURL=update-partner-contact.schema.js.map